<script setup>
import {computed, nextTick, ref, watch} from 'vue'
import FormGroup from "@/common/form/FormGroup.vue"
import PageEditorPageSettings from "./PageEditorPageSettings.vue"
import {usePageEditorStore} from '@/stores/pageEditor'
import {useFormStore} from '@/stores/form'
import {useSiteTreeStore} from '@/stores/siteTree'

const props = defineProps({
    formId: String
})

const pageEditorStore = usePageEditorStore()
const formStore = useFormStore(props.formId)

const siteTreeId = computed(() => pageEditorStore.siteTreeId)
const siteTreeStore = computed(() => siteTreeId.value ? useSiteTreeStore(siteTreeId.value) : null)

const form = ref(null)
const isSaving = ref(false)

const activeTab = computed(() => pageEditorStore.pagePanelActiveTab)
const fields = computed(() => formStore.fields)
const modifiedData = computed(() => formStore.modifiedData)

const registerFormEl = () => {
    if (props.formId && form.value) {
        formStore.setFormEl(form.value)
    }
}

nextTick(() => {
    registerFormEl()
})

watch(
    () => props.formId,
    () => {
        nextTick(() => {
            registerFormEl()
        })
    }
)

watch(modifiedData, (newValue) => {
    if (isSaving.value) return
    isSaving.value = true

    nextTick(async () => {
        const isValid = await formStore.validateForm()
        if (isValid) {
            formStore.save()
                .then(() => {
                    isSaving.value = false

                    const columnName = Object.keys(newValue || {})[0]
                    if (columnName === 'groupAccess' && siteTreeStore.value) {
                        setTimeout(() => {
                            siteTreeStore.value.init()
                        }, 1000)
                    }
                })
        } else {
            isSaving.value = false
        }
    })
})
</script>

<template>
    <form ref="form">
        <FormGroup class="mb-3" v-for="(field, i) in fields" :key="i" :form-id="formId" :field="field"
                   :hide-help-text="true"/>

        <PageEditorPageSettings v-if="activeTab === 'Settings'" :form-id="formId"/>
    </form>
</template>